export function parseSize(size?: string) {
    if (!size) return { w: 0, h: 0 };

    const [w, h] = size.split("x").map(parseFloat);

    return { w, h };
}